import { node } from 'prop-types';
import React from 'react';
import LogoBranded from './images/LogoBranded';
import TeamChillGraphic from './images/TeamChillGraphic';
import useStyles from '../hooks/useStyles';
import { PATH } from '../consts';

PageWrapper.propTypes = {
	children: node
};

export default function PageWrapper({ children }) {
	const classes = useStyles(styles);
	return (
		<div css={classes.container}>
			<div css={classes.wrapper}>
				<header css={classes.header}>
					<svg css={classes.headerBg} preserveAspectRatio="none" viewBox="0 0 1440 159">
						<path
							d="M888 121c-219.008833-72.5201555-348.127912-40.016545-532.479297 10.420866-4.153289 1.231818-8.352405 2.420212-12.620619 3.550287-24.58474 6.50596-50.564387 11.174821-77.834422 13.84797-27.246764 2.688043-55.759932 3.381631-85.070198 1.845545-67.709791-3.54852-130.0198324-18.497964-181.24054621-41.206115-1.48565548-.65865-1.48565548-37.1448339 0-109.458553H1440l.94838 63.5504057c-124.65502 64.0458703-217.64841 94.2199793-323.2984 94.5847863C1047.21666 158.378397 970.666667 146 888 121z"
							fill="#F0EEF9"
							fillRule="evenodd"
						/>
					</svg>
					<a href={PATH.marketingSite}>
						<LogoBranded css={classes.logo} />
					</a>
				</header>
				<TeamChillGraphic css={classes.teamLogo} />
				<main css={classes.content}>{children}</main>
			</div>
			<footer css={classes.footer}>
				<svg css={classes.footerBg} preserveAspectRatio="none" viewBox="0 0 1024 70">
					<path
						d="M-210 10C-133.334635 3.33333-27.5091146 0 107.476562 0c202.478516 0 186.076172 10 404.957032 10C731.314453 10 810.292969 0 950.195312 0 1043.46354 0 1136.73177 3.33333 1230 10v60H-210V10z"
						fill="#F6F5FA"
						fillRule="evenodd"
					/>
				</svg>
				By{' '}
				<a css={classes.footerLink} href="https://www.deltatre.com/">
					Deltatre
				</a>
			</footer>
		</div>
	);
}

const styles = ({ css }) => ({
	container: css`
		width: 100%;
		min-height: 100vh;
		display: flex;
		flex-direction: column;
	`,
	wrapper: css`
		max-width: 1200px;
		width: 100%;
		padding: 40px 16px;
		display: flex;
		margin: auto;
		align-items: center;
		flex-direction: column;
		overflow: hidden;
	`,
	content: css`
		margin-top: 140px;
	`,
	header: css`
		position: absolute;
		top: 0;
		height: 160px;
		width: 100%;
		overflow: hidden;
	`,
	headerBg: css`
		width: 100%;
		min-width: 600px;
		height: 160px;
		z-index: -1;
	`,
	logo: css`
		position: absolute;
		top: 40px;
		left: 5vw;
		width: 22vw;
		min-width: 160px;
		max-width: 300px;
		align-items: flex-start;
	`,
	teamLogo: css`
		position: absolute;
		right: 12vw;
		top: 36px;
		width: 285px;
		@media screen and (max-width: 1030px) {
			right: 6vw;
			width: 200px;
			top: 70px;
		}
		@media screen and (max-width: 560px) {
			display: none;
		}
	`,
	footer: css`
		height: 70px;
		width: 100%;
		margin: auto auto 0 auto;
		align-items: center;
		justify-content: center;
		display: flex;
		font-size: 14px;
		color: #535969;
	`,
	footerBg: css`
		position: absolute;
		width: 100%;
		height: 70px;
		z-index: -1;
	`,
	footerLink: css`
		color: #535969;
		max-width: 50%;
		margin-left: 0.3em;
	`
});
